import React from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './App.css';

function App() {
  const { user, isAuthenticated, logout, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isShop = location.pathname.startsWith('/shop');

  if (loading) {
    return (
      <div className="App">
        <div className="loading-screen">
          <img src="/flessing-labs-logo.png" alt="Flessing Labs" className="loading-logo" />
          <p>Lädt…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <header className="App-header">
        <div className="header-inner">
          <div className="header-brand">
            <img src="/flessing-labs-logo.png" alt="Flessing Labs" className="header-logo" />
            <span className="header-product">
              {isShop ? 'Shop' : 'License Manager'}
            </span>
          </div>

          {!isShop && (
            isAuthenticated ? (
              <div className="header-right">
                <nav>
                  <ul>
                    <li><Link to="/programs">Programme</Link></li>
                    <li><Link to="/products">Produkte</Link></li>
                    <li><Link to="/licenses">Lizenzen</Link></li>
                    <li><Link to="/discord">Discord</Link></li>
                  </ul>
                </nav>
                <div className="user-info">
                  <span className="user-name">{user?.username}</span>
                  <Link to="/change-password" className="change-password-link">Passwort</Link>
                  <button onClick={handleLogout} className="logout-btn">Abmelden</button>
                </div>
              </div>
            ) : (
              <nav>
                <ul>
                  <li><Link to="/login">Anmelden</Link></li>
                </ul>
              </nav>
            )
          )}

          {isShop && (
            <nav>
              <ul>
                <li><a href="https://flessinglabs.com">flessinglabs.com</a></li>
              </ul>
            </nav>
          )}
        </div>
      </header>
      <main>
        <Outlet />
      </main>
      <footer className="App-footer">
        <span>© 2026 Flessing Labs</span>
        <Link to="/shop">Shop</Link>
        <a href="https://flessinglabs.com" rel="noreferrer">Website</a>
      </footer>
    </div>
  );
}

export default App;
